import { KeyValuePipe } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

import { DemoNumberFields } from '@demo/data/demo-cipo-fields';
import { CipoNumberComponent } from '@shared/components/fields/cipo-number/cipo-number.component';
import { CipoNumberControl } from '@shared/components/fields/common';
import { isNil } from 'lodash';

@Component({
  selector: 'app-demo-cipo-number',
  imports: [CipoNumberComponent, FlexLayoutModule, KeyValuePipe, MatButton],
  templateUrl: './demo-cipo-number.component.html',
})
export class DemoCipoNumberComponent {
  dialog = inject(MatDialog);

  form = signal(new FormGroup<{ [x: string]: CipoNumberControl }>({}));
  lastValue = signal<string>(null);

  constructor() {
    DemoNumberFields.forEach(field => {
      const { name, defaultValue, ...props } = field;
      const control = new CipoNumberControl(defaultValue, props);
      control.valueChanges.subscribe(value => {
        const values = (Array.isArray(value) ? value : [value]).filter(v => !isNil(v));
        this.lastValue.set(values.map(v => v.toString()).join(', '));
      });
      this.form().addControl(name, control);
    });
  }

  markAsTouched(touched: boolean) {
    if (touched) {
      this.form().markAllAsTouched();
    } else {
      this.form().markAsUntouched();
    }
    this.form().updateValueAndValidity();
  }
}
